import React, { useState, useRef } from 'react';
import { TabView, Tabs, TabContent } from 'mrf/styles/components/Tabs.styles';
import T from 'mrf/utils/T';
import PropTypes from 'prop-types';
import { Grid, Col } from 'mrf/view/Grid';
import tw from 'twin.macro';
import styled from 'styled-components';

const Tab = styled.a`
    ${tw`px-2 pt-3 pb-5 mr-px rounded-lg hover:bg-gray-200 hover:bg-opacity-80 bg-gray-100 shadow`}

    &.active-tab {
        ${tw`bg-blue-300`}
    }
`;

export default function TabContainer({ match, tabs, bgColorTabContent }) {
    let initialSelectedTab = tabs[0]?.pathSuffix;

    const currentPathSuffix = window.location.href.split('/').pop();

    if (tabs?.map(tab => tab?.pathSuffix).includes(currentPathSuffix)) {
        initialSelectedTab = currentPathSuffix
    }

    const [selectedTab, setSelectedTab] = useState(initialSelectedTab);
    const tabRefs = useRef({});

    // find the tab corresponding to the selected one
    const activeTab = tabs.find(tab => tab.pathSuffix === selectedTab);

    return (
        <TabView>
            <Tabs>
                {tabs.map(({ label, pathSuffix }) => (
                    <Tab
                        key={pathSuffix}
                        className={`cursor-pointer ${selectedTab === pathSuffix ? 'active-tab' : ''}`}
                        onClick={() => setSelectedTab(pathSuffix)}
                    >
                        <T>{label}</T>
                    </Tab>
                ))}
            </Tabs>
            <TabContent color='lightBlue' bgColor={bgColorTabContent}>
                <Grid>
                    <Col>
                        {activeTab && (
                            <div ref={(el) => (tabRefs.current[activeTab.pathSuffix] = el)}>
                                <activeTab.component match={match} />
                            </div>
                        )}
                    </Col>
                </Grid>
            </TabContent>
        </TabView>
    );
}

TabContainer.propTypes = {
    match: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }).isRequired,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            pathSuffix: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
        })
    ).isRequired,
    bgColorTabContent: PropTypes.string,
};